export const CONTACT_LINK = 'https://www.wienerwohnen.at/mieterin/servicemieterin/kontakt.html';
export const REQUEST_SERVICECARD_LINK = 'https://servicekarte.wienerwohnen.at/';
export const COMPLEX_INFORMATION = '/hof-informationen';
